export default [
    'Alef',
    'Amiri',
    'Amiri Quran',
    'Arial',
    'Arial Black',
    'Bahnschrift',
    'Caladea',
    'Calibri',
    'Cambria',
    'Cambria Math',
    'Candara',
    'Carlito',
    'Comic Sans MS',
    'Consolas',
    'Constantia',
    'Corbel',
    'Courier',
    'Courier New',
    'David CLM',
    'David Libre',
    'DejaVu Math TeX Gyre',
    'DejaVu Sans',
    'DejaVu Sans Mono',
    'DejaVu Serif',
    'EmojiOne Color',
    'Fixedsys',
    'Frank Ruehl CLM',
    'Frank Ruhl Hofshi',
    'Franklin Gothic',
    'Gabriola',
    'Gentium Basic',
    'Gentium Book Basic',
    'Georgia',
    'HoloLens MDL2 Assets',
    'HP Simplified',
    'Impact',
    'Ink Free',
    'KacstBook',
    'KacstOffice',
    'Liberation Mono',
    'Liberation Sans',
    'Liberation Serif',
    'Linux Biolinum G',
    'Linux Libertine Display G',
    'Linux Libertine G',
    'Lucida Console',
    'Lucida Sans Unicode',
    'Microsoft Sans Serif',
    'Miriam CLM',
    'Miriam Libre',
    'Miriam Mono CLM',
    'Modern',
    'MS Sans Serif',
    'MS Serif',
    'Nachlieli CLM',
    'Noto Kufi Arabic',
    'Noto Mono',
    'Noto Naskh Arabic',
    'Noto Naskh Arabic UI',
    'Noto Sans',
    'Noto Sans Arabic',
    'Noto Sans Arabic UI',
    'Noto Sans Armenian',
    'Noto Sans Georgian',
    'Noto Sans Hebrew',
    'Noto Sans Lao',
    'Noto Sans Lisu',
    'Noto Serif',
    'Noto Serif Armenian',
    'Noto Serif Georgian',
    'Noto Serif Hebrew',
    'Noto Serif Lao',
    'OpenSymbol',
    'Palatino Linotype',
    'qtquickcontrols',
    'Reem Kufi',
    'Roman',
    'Rubik',
    'Scheherazade',
    'Script',
    'Segoe MDL2 Assets',
    'Segoe Print',
    'Segoe Script',
    'Segoe UI',
    'Segoe UI Emoji',
    'Segoe UI Symbol',
    'Sitka Banner',
    'Sitka Display',
    'Sitka Heading',
    'Sitka Small',
    'Sitka Subheading',
    'Sitka Text',
    'Small Fonts',
    'Source Code Pro',
    'Source Sans Pro',
    'Symbol',
    'System',
    'Tahoma',
    'Terminal',
    'Times New Roman',
    'Trebuchet MS',
    'Verdana',
    'Webdings',
    'Wingdings',
]